import { INavigationTileItem } from '../../models/navigation_tile_item'

export const profileTiles = (isMainUser: boolean): INavigationTileItem[] => {
  const mainUserTiles: INavigationTileItem[] = [
    {
      icon: 'user-lock',
      title: 'Accountgegevens wijzigen',
      href: '/mijn-profiel/accountgegevens-wijzigen'
    },
    {
      icon: 'address-card',
      title: 'Gegevens wijzigen',
      href: '/mijn-profiel/gegevens-wijzigen'
    },
    {
      icon: 'cog',
      title: 'Voorkeuren',
      href: '/mijn-profiel/voorkeuren'
    },
    {
      icon: 'user-plus',
      title: 'Gebruikers beheren',
      href: '/mijn-profiel/gebruikers-beheren'
    },
    {
      icon: 'file-alt',
      title: 'Selecteer combipolis',
      href: '/mijn-profiel/combipolis-selecteren'
    }
  ]

  const subUserTiles: INavigationTileItem[] = [
    {
      icon: 'user-lock',
      title: 'Accountgegevens wijzigen',
      href: '/mijn-profiel/accountgegevens-wijzigen'
    },
    {
      icon: 'address-card',
      title: 'Gegevens wijzigen',
      href: '/mijn-profiel/gegevens-wijzigen'
    },
    {
      icon: 'cog',
      title: 'Voorkeuren',
      href: '/mijn-profiel/voorkeuren'
    },
    {
      icon: 'file-alt',
      title: 'Selecteer combipolis',
      href: '/mijn-profiel/combipolis-selecteren'
    }
  ]

  return isMainUser ? mainUserTiles : subUserTiles
}

export const appProfileTiles = (isMainUser: boolean): INavigationTileItem[] => {
  const mainUserTiles: INavigationTileItem[] = [
    {
      icon: 'user-lock',
      title: 'Accountgegevens wijzigen',
      href: '/dashboard/profile/login-information'
    },
    {
      icon: 'address-card',
      title: 'Gegevens wijzigen',
      href: '/dashboard/profile/general-information'
    },
    {
      icon: 'fingerprint',
      title: 'Inlogmethode wijzigen',
      href: '/dashboard/profile/change-authentication-method'
    },
    {
      icon: 'cog',
      title: 'Voorkeuren',
      href: '/dashboard/profile/preferences'
    },
    {
      icon: 'user-plus',
      title: 'Gebruikers beheren',
      href: '/dashboard/profile/manage-users'
    },
    {
      icon: 'file-alt',
      title: 'Selecteer combipolis',
      href: '/dashboard/profile/select-combipolis'
    },
    {
      icon: 'user-check',
      title: 'Toestemmingen',
      href: '/dashboard/profile/permissions'
    }
  ]

  const subUserTiles: INavigationTileItem[] = [
    {
      icon: 'user-lock',
      title: 'Accountgegevens wijzigen',
      href: '/dashboard/profile/login-information'
    },
    {
      icon: 'fingerprint',
      title: 'Inlogmethode wijzigen',
      href: '/dashboard/profile/change-authentication-method'
    },
    {
      icon: 'cog',
      title: 'Voorkeuren',
      href: '/dashboard/profile/preferences'
    },
    {
      icon: 'address-card',
      title: 'Gegevens wijzigen',
      href: '/dashboard/profile/general-information'
    },
    {
      icon: 'file-alt',
      title: 'Selecteer combipolis',
      href: '/dashboard/profile/select-combipolis'
    },
    {
      icon: 'user-check',
      title: 'Toestemmingen',
      href: '/dashboard/profile/permissions'
    }
  ]

  return isMainUser ? mainUserTiles : subUserTiles
}
